import Application from "../../Application";
import IndexTypeGroupDetailsPresenter, {
  IIndexTypeGroupDetailsPresenter
} from "../presenter/IndexTypeGroupDetailsPresenter";
import { TIndexTypeGroupPresentationModel } from "../presenter/model/IndexTypeGroupPresentationModel";
import FindIndexTypeGroupInteractor from "./FindIndexTypeGroupInteractor";
import GetAllIndexTypeCategoriesInteractor from "./GetAllIndexTypeCategoriesInteractor";

export default class ShowGroupDetailsInteractor {
  private application: Application;
  private output?: IIndexTypeGroupDetailsPresenter;
  private findIndexTypeGroupInteractor: FindIndexTypeGroupInteractor;
  private getAllIndexTypeCategoriesInteractor: GetAllIndexTypeCategoriesInteractor;

  constructor({
    application,
    findIndexTypeGroup,
    getAllIndexTypeCategories
  }: any) {
    this.application = application;
    this.findIndexTypeGroupInteractor = findIndexTypeGroup;
    this.getAllIndexTypeCategoriesInteractor = getAllIndexTypeCategories;
  }

  private async getAllCategories() {
    return this.getAllIndexTypeCategoriesInteractor.execute();
  }

  private async getReferenceLists() {
    return Promise.all([this.getAllCategories()]);
  }

  execute(id: number) {
    this.output = IndexTypeGroupDetailsPresenter({
      application: this.application,
      initialState: {
        indexTypeGroup: {} as TIndexTypeGroupPresentationModel,
        categories: []
      }
    });
    this.getReferenceLists()
      .then(([categories]) => this.output?.loadReferenceValues(categories))
      .then(() => this.findIndexTypeGroupInteractor.execute(id))
      .then(this.output.loadIndexTypeGroupDetails);
    return this.output;
  }
}
